module.exports = __webpack_public_path__ + "static/media/pablo-iglesias.0a7cabc4.png";